module.exports = __webpack_public_path__ + "static/foto-av.ea963a79.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/foto-av.jpg
// module id = 53
// module chunks = 35783957827783 114276838955818 213720915766396